export const CLEAR_USER_SESSION = "CLEAR_USER_SESSION";
export const SET_USER_SESSION = "SET_USER_SESSION";
export const DIM_SCREEN = "DIM_SCREEN";
export const CLEAR_DIM = "CLEAR_DIM";
